import { createFileRoute } from '@tanstack/react-router'
import { shiftSearchSchema } from '../../../../features/pos/search'
import { ShiftsListPage } from '../../../../features/pos/shifts-list-page'

export const Route = createFileRoute('/_app/pos/shifts/')({
  validateSearch: shiftSearchSchema,
  component: ShiftsListPage,
})
